import React from 'react';
import starActive from '../../../static/images/mvp/star_active.png';
import starInactive from '../../../static/images/mvp/star_in_active.png';

function RatingStarsDisplay({
  score,
  maxStars = 5,
  size = 14,
  activeColor = '#61E6BD',
  inactiveColor = '#BDBDBD',
  variant = 'glyph',
  imgGap = 12,
}) {
  if (variant === 'img') {
    const dim = typeof size === 'number' ? `${size}px` : size;
    return (
      <span
        className="rating-stars-display rating-stars-display--img"
        style={{ display: 'inline-flex', gap: `${imgGap}px`, alignItems: 'center', lineHeight: 0 }}
      >
        {Array.from({ length: maxStars }, (_, i) => (
          <img
            key={i}
            src={i < score ? starActive : starInactive}
            alt=""
            className="rating-star-img"
            style={{ width: dim, height: dim, objectFit: 'contain', display: 'block' }}
          />
        ))}
      </span>
    );
  }

  return (
    <span className="rating-stars-display" style={{ display: 'inline-flex', gap: '2px' }}>
      {Array.from({ length: maxStars }, (_, i) => (
        <span
          key={i}
          style={{
            fontSize: size,
            color: i < score ? activeColor : inactiveColor,
            lineHeight: 1,
          }}
        >
          ★
        </span>
      ))}
    </span>
  );
}

export default RatingStarsDisplay;
